export default __webpack_public_path__ + "86e81402ef76d28ff55f1a48e51a87ec.svg";